function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 0.5C9.172 0.5 8.5 1.172 8.5 2C8.5 2.828 9.172 3.5 10 3.5C10.828 3.5 11.5 2.828 11.5 2C11.5 1.172 10.828 0.5 10 0.5ZM18 0.5C17.172 0.5 16.5 1.172 16.5 2C16.5 2.828 17.172 3.5 18 3.5C18.828 3.5 19.5 2.828 19.5 2C19.5 1.172 18.828 0.5 18 0.5ZM2 0.5C1.172 0.5 0.5 1.172 0.5 2C0.5 2.828 1.172 3.5 2 3.5C2.828 3.5 3.5 2.828 3.5 2C3.5 1.172 2.828 0.5 2 0.5Z",
  fill: "#022345"
});
function SvgMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 4,
    viewBox: "0 0 20 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.cf5ca27b.svg";
export { ForwardRef as ReactComponent };